module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "cart"
  }, [_c('div', {
    staticClass: "main"
  }, [_c('form', [_c('div', {
    staticClass: "list order edit-address"
  }, [_c('ul', [_c('li', [_c('label', [_vm._v("姓名")]), _vm._v(" "), _c('div', {
    staticClass: "input-box"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.addressee),
      expression: "addressee"
    }],
    attrs: {
      "placeholder": "请输入您的姓名",
      "maxlength": 6
    },
    domProps: {
      "value": (_vm.addressee)
    },
    on: {
      "blur": _vm.inputBlur,
      "focus": _vm.inputFocus,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.addressee = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('li', [_c('div', {
    staticClass: "sex-box",
    staticStyle: {
      "margin-top": "0.3rem"
    }
  }, [_c('label', {
    staticClass: "icon icon-boy",
    class: {
      'checked': _vm.gender === '1'
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.gender),
      expression: "gender"
    }],
    staticClass: "sex",
    attrs: {
      "type": "radio",
      "name": "sex",
      "value": "1"
    },
    domProps: {
      "checked": _vm._q(_vm.gender, "1")
    },
    on: {
      "change": function($event) {
        _vm.gender = "1"
      }
    }
  }), _vm._v("男\n                ")]), _vm._v(" "), _c('label', {
    staticClass: "icon icon-girl",
    class: {
      'checked': _vm.gender === '0'
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.gender),
      expression: "gender"
    }],
    staticClass: "sex",
    attrs: {
      "type": "radio",
      "name": "sex",
      "value": "0"
    },
    domProps: {
      "checked": _vm._q(_vm.gender, "0")
    },
    on: {
      "change": function($event) {
        _vm.gender = "0"
      }
    }
  }), _vm._v("女\n                ")])])]), _vm._v(" "), _c('li', [_c('label', [_vm._v("电话")]), _vm._v(" "), _c('div', {
    staticClass: "input-box"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.mp),
      expression: "mp"
    }],
    attrs: {
      "type": "tel",
      "placeholder": "请输入您的手机号",
      "maxlength": 11
    },
    domProps: {
      "value": (_vm.mp)
    },
    on: {
      "blur": _vm.inputBlur,
      "focus": _vm.inputFocus,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.mp = $event.target.value
      }
    }
  })])]), _vm._v(" "), (!_vm.needBuilding) ? _c('li', [_c('a', {
    staticClass: "arrow-right",
    on: {
      "click": _vm.chooseAddress
    }
  }, [_c('label', [_vm._v("地址")]), _vm._v(" "), _c('div', {
    staticClass: "input-box"
  }, [_vm._v(_vm._s(_vm.poi_address))])])]) : _vm._e(), _vm._v(" "), (_vm.needBuilding) ? _c('li', [_c('a', {
    staticClass: "arrow-right",
    on: {
      "click": _vm.toggleBuildProp
    }
  }, [_c('label', [_vm._v("楼栋")]), _vm._v(" "), _c('div', {
    staticClass: "input-box"
  }, [_vm._v(_vm._s(_vm.buildInfo.name ? _vm.buildInfo.name : '请选择楼栋'))])])]) : _vm._e(), _vm._v(" "), (_vm.needBuilding) ? _c('li', [_c('a', {
    staticClass: "arrow-right",
    on: {
      "click": _vm.toggleFloorProp
    }
  }, [_c('label', [_vm._v("楼层")]), _vm._v(" "), _c('div', {
    staticClass: "input-box"
  }, [_vm._v(_vm._s(_vm.floorInfo.name ? _vm.floorInfo.name : '请选择楼层'))])])]) : _vm._e(), _vm._v(" "), (_vm.needBuilding) ? _c('li', [_c('a', {
    staticClass: "arrow-right",
    on: {
      "click": _vm.toggleRoomProp
    }
  }, [_c('label', [_vm._v("房间")]), _vm._v(" "), _c('div', {
    staticClass: "input-box"
  }, [_vm._v(_vm._s(_vm.roomInfo.name ? _vm.roomInfo.name : '请选择房间'))])])]) : _vm._e(), _vm._v(" "), (!_vm.needBuilding) ? _c('li', [_c('label', [_vm._v("详细")]), _vm._v(" "), _c('div', {
    staticClass: "input-box"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.detail),
      expression: "detail"
    }],
    attrs: {
      "placeholder": "请输入您的详细地址",
      "maxlength": 20
    },
    domProps: {
      "value": (_vm.detail)
    },
    on: {
      "blur": _vm.inputBlur,
      "focus": _vm.inputFocus,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.detail = $event.target.value
      }
    }
  })])]) : _vm._e()])])])]), _vm._v(" "), _c('footer', {
    staticClass: "block",
    staticStyle: {
      "width": "100%",
      "position": "absolute",
      "bottom": "0",
      "left": "0",
      "right": "0"
    }
  }, [_c('a', {
    staticClass: "btn btn-main btn-lg btn-block",
    on: {
      "click": _vm.addAddress
    }
  }, [_vm._v("完成")])]), _vm._v(" "), (_vm.propShow) ? _c('div', {
    staticClass: "mask",
    on: {
      "click": _vm.closeProp
    }
  }) : _vm._e(), _vm._v(" "), (_vm.propBuildShow) ? _c('div', {
    staticClass: "prop-box"
  }, [_c('div', {
    staticClass: "title ac"
  }, [_vm._v(_vm._s(_vm.buildTitle))]), _vm._v(" "), _c('ul', {
    staticClass: "flex-ui item3",
    staticStyle: {
      "left": "0",
      "right": "0"
    }
  }, _vm._l((_vm.buildingList), function(item) {
    return _c('li', {
      class: {
        'canSelect': item.id == _vm.buildInfo.id
      },
      on: {
        "click": function($event) {
          return _vm.changeBuilding(item)
        }
      }
    }, [_vm._v(_vm._s(item.area))])
  }), 0)]) : _vm._e(), _vm._v(" "), (_vm.propFloorShow) ? _c('div', {
    staticClass: "prop-box"
  }, [_c('div', {
    staticClass: "title ac"
  }, [_vm._v(_vm._s(_vm.floorTitle))]), _vm._v(" "), _c('ul', {
    staticClass: "flex-ui item5",
    staticStyle: {
      "left": "0",
      "right": "0"
    }
  }, _vm._l((_vm.floorList), function(item) {
    return _c('li', {
      staticClass: "ellipses",
      class: {
        'canSelect': item.id == _vm.floorInfo.id
      },
      on: {
        "click": function($event) {
          return _vm.changeFloor(item)
        }
      }
    }, [_vm._v(_vm._s(item.area))])
  }), 0)]) : _vm._e(), _vm._v(" "), (_vm.propRoomShow) ? _c('div', {
    staticClass: "prop-box"
  }, [_c('div', {
    staticClass: "title ac"
  }, [_vm._v(_vm._s(_vm.roomTitle))]), _vm._v(" "), _c('ul', {
    staticClass: "flex-ui item5",
    staticStyle: {
      "left": "0",
      "right": "0"
    }
  }, _vm._l((_vm.roomList), function(item) {
    return _c('li', {
      staticClass: "ellipses",
      class: {
        'canSelect': item.id == _vm.roomInfo.id
      },
      on: {
        "click": function($event) {
          return _vm.changeRoom(item)
        }
      }
    }, [_vm._v(_vm._s(item.area))])
  }), 0), _vm._v(" "), (_vm.isCustom) ? _c('div', {
    staticClass: "custom",
    on: {
      "click": _vm.changeOpenCustom
    }
  }, [_vm._v("\n      没有找到自己房间号？点击这里添加\n    ")]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.openCustomRoom) ? _c('div', {
    staticClass: "custom-pop"
  }, [_c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("自定义房间号")]), _vm._v(" "), _c('div', {
    staticClass: "input"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.customRoomName),
      expression: "customRoomName"
    }],
    attrs: {
      "autofocus": "",
      "type": "text",
      "placeholder": "请输入你的房间号",
      "maxlength": "10"
    },
    domProps: {
      "value": (_vm.customRoomName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.customRoomName = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "tips"
  }, [_vm._v("温馨提示：为确保餐品顺利送到，请填写真实房间号")]), _vm._v(" "), _c('div', {}, [_c('div', {
    staticClass: "btn",
    on: {
      "click": function($event) {
        return _vm.changeOpenCustom()
      }
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('div', {
    staticClass: "btn btn-ok",
    on: {
      "click": _vm.choseCustomRoom
    }
  }, [_vm._v("确定")])])])]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@12.2.2@vue-loader/lib/template-compiler?{"id":"data-v-2c1ca71e","hasScoped":true}!./~/_vue-loader@12.2.2@vue-loader/lib/selector.js?type=template&index=0!./src/pages/AddAddress.vue
// module id = 421
// module chunks = 7